import { Component, Input } from '@angular/core';

import { FiltersComponent } from '../../../common/filters.component';
import { DateService } from '../../../common/date.service';

@Component({
	selector: 'app-tourism-briefing-filters',
	templateUrl: './tourism-briefing-filters.component.html',
	styleUrls: ['./tourism-briefing-filters.component.css'],
})
export class TourismBriefingFiltersComponent extends FiltersComponent {
	@Input() statuses: Array<any>;
	@Input() categories: Array<any>;
	@Input() vehicle_busTypes: Array<any>;
	@Input() vehicle_statuses: Array<any>;
	@Input() yesno: Array<any>;
	@Input() users: Array<any>;
	@Input() filters = {
		date_from: null,
		date_to: null,
		status: null,
		vehicle: null,
		showDeleted: null,
		search: null,
		category: null,
		vehicle_busType: null,
		vehicle_status: null,
		driver_informed: null,
		guide_informed: null,
		owners: null,
		haveOpinion: null,
	};

	filtersDefault() {
		this.filtersClear();
		const date = new DateService();
		this.filters.vehicle_status = ['1', '5'];
		this.filters.category = ['RENT', 'OSKAR', 'SERVICE', 'SERVICE', 'OTHER', 'FOREIGN', 'GROUP'];
		this.filters.date_from = date.daysAdd(-1);
		this.filters.date_to = date.daysAdd(+7);
	}
}
